/**
 * @generated SignedSource<<dfd3f005f0718bea9cd604215f2c3fc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type paywallsGetArticlePaywallTagArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsArchiveWallArticle" | "helpersIsLiteWallArticle" | "helpersIsVelocityWallArticle" | "hooksVelocityWallThresholdABTest">;
  readonly " $fragmentType": "paywallsGetArticlePaywallTagArticle";
};
export type paywallsGetArticlePaywallTagArticle$key = {
  readonly " $data"?: paywallsGetArticlePaywallTagArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"paywallsGetArticlePaywallTagArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "paywallsGetArticlePaywallTagArticle"
};

(node as any).hash = "c1961789987d62e067e1f7f2f92ca513";

export default node;
